<section *ngIf="(selectedProject$ | async) as selectedProject" fxLayout="row" class="h-100">
    <section class="sen-body-max-width" fxFlex="1 1 65%">
        <agm-map #agmMap class="h-100 w-100" [streetViewControl]="false" id="google_map_modal_id" [disableDoubleClickZoom]="true"
            [mapTypeId]="'hybrid'" [zoom]="20" [latitude]="selectedProject.address.lat"
            [longitude]="selectedProject.address.lon" [fullscreenControl]="isOpenWindow">
            <agm-marker [latitude]="selectedProject.address.lat" [longitude]="selectedProject.address.lon">
                <agm-info-window [isOpen]="isOpenWindow">
                    <strong><span>{{translate.getLng('PROJECT_LOCATION')}}</span><br>
                        {{selectedProject.address.full}}, {{selectedProject.address.location}},
                        {{selectedProject.address.postalCode}} </strong>
                </agm-info-window>
            </agm-marker>
        </agm-map>
    </section>
    <section fxFlex="1 1 33%" fxLayout="column" class="px-3 sen-tool-bar sen-light-blue-bg">
        <div fxFlex="1 1 auto">
            <h2>{{translate.getLng('ROOF_PLAN')}}</h2>
            <mat-card fxLayout="row" fxLayoutAlign="space-between" class="sen-fs10 p-3">
                <div title="{{selectedProject.name}}" fxFlex="1 1 auto"><label
                        class="set-blue-color">{{translate.getLng('PROJECT_NAME')}}</label>
                    <br>{{selectedProject.name | truncate:30}}</div>
                <mat-divider class="mx-2" [vertical]="true"></mat-divider>
                <div fxFlex="1 1 auto"><label class="set-blue-color">{{translate.getLng('PROJECT_LOCATION')}}</label>
                    <br>{{selectedProject.address.full}}, {{selectedProject.address.location}},
                    {{selectedProject.address.postalCode}}</div>
            </mat-card>
            <mat-form-field [formGroup]="form" id="senProjectNameField" class="mt-2 w-100 example-full-width">
                <mat-label>{{translate.getLng('NAME')}}</mat-label>
                <input #planNameField formControlName="planName" (input)="checkPlanExistName($event)" autocomplete="off"
                    matInput>
                <mat-icon matSuffix matTooltipClass="sen-snackbar-color"
                    matTooltip="{{translate.getLng('EXISTING_PLAN_NAME_WARNING')}}" class="sen-fs16"
                    *ngIf="planNameExist" color="invalid">
                    warning</mat-icon>
            </mat-form-field>
            <div>
                <h5>{{translate.getLng('ROOF_PLAN')}}</h5>
                <div fxLayout="row wrap" class="sen-slider-wrapper" fxLayoutAlign="space-evenly flex-start">
                    <div fxFlex="1 1 49%" class="position-relative">
                        <h6 class="position-absolute">{{translate.getLng('MONSYS')}}</h6>
                        <ngb-carousel #mountSlide (swipe)="onSwipeCarousel($event, mountSlide)"
                            (slide)="mountSlideDone($event, roofTypeSlide)" [interval]="false">
                            <ng-template *ngFor="let slide of mountingSystem; let i = index" ngbSlide
                                [id]="prefixMS + i">
                                <div class="picsum-img-wrapper">
                                    <img class="w-100" [src]="slide.src">
                                </div>
                                <div class="carousel-caption">
                                    {{slide.label}}
                                </div>
                            </ng-template>
                        </ngb-carousel>
                    </div>


                    <div fxFlex="1 1 49%" class="position-relative">
                        <h6 class="position-absolute">{{translate.getLng('ROOFTYPE')}}</h6>
                        <ngb-carousel #roofTypeSlide *ngIf="selectedMountingSystem"
                            (swipe)="onSwipeCarousel($event, roofTypeSlide)" [interval]="false"
                            (slide)="roofTypeSlideDone($event)">
                            <ng-template *ngFor="let slide of selectedMountingSystem.roofType; let i = index"
                                [id]="prefixRT + i" ngbSlide>
                                <div class="picsum-img-wrapper">
                                    <img class="w-100" [src]="slide.src">
                                </div>
                                <div class="carousel-caption">
                                    {{slide.label}}
                                </div>
                            </ng-template>
                        </ngb-carousel>
                    </div>

                    <div fxFlex="1 1 49%" class="mt-5 position-relative">
                        <h6 class="position-absolute">{{translate.getLng('PROFILE_COLOR')}}</h6>
                        <ngb-carousel [interval]="false" *ngIf="selectedMountingSystem">
                            <ng-template ngbSlide>
                                <div class="picsum-img-wrapper">
                                    <img class="w-100" [src]="selectedMountingSystem.profile.src">
                                </div>
                                <div class="carousel-caption">
                                    {{selectedMountingSystem.profile.label}}
                                </div>
                            </ng-template>
                        </ngb-carousel>
                    </div>

                    <div fxFlex="1 1 49%" class="mt-5 position-relative">
                        <ng-container *ngIf="selectedRoofType?.subType?.types; else placeHolderSlide">
                            <h6 class="position-absolute">{{selectedRoofType!.subType!.title}}</h6>
                            <ngb-carousel [interval]="false" (slide)="subTypeSlideDone($event)"
                                (swipe)="onSwipeCarousel($event, subTypeSlide)" #subTypeSlide>
                                <ng-template *ngFor="let slide of selectedRoofType!.subType!.types; let i = index"
                                    [id]="prefixST + i" ngbSlide>
                                    <div class="picsum-img-wrapper">
                                        <img class="w-100" [src]="slide.src">
                                    </div>
                                    <div class="carousel-caption">
                                        {{slide.label}}
                                    </div>
                                </ng-template>
                            </ngb-carousel>
                        </ng-container>
                        <ng-template #placeHolderSlide>
                            <ngb-carousel [interval]="false" [showNavigationArrows]="false"
                                [showNavigationIndicators]="false">
                                <ng-template ngbSlide>
                                    <div class="picsum-img-wrapper">
                                        <img class="w-100 sen-opacity-50" [src]="imagePath.slidePlaceholder">
                                    </div>
                                </ng-template>
                            </ngb-carousel>
                        </ng-template>
                    </div>

                </div>
            </div>
        </div>
        <!--<div><input type="checkbox" [(ngModel)]="isFlatRoof" (change) = "isFlatRoofEnabled($event)" name="flatroof"> FlatRoof </div>-->
        <div class="my-2" fxLayout="row" fxLayoutAlign="space-evenly center">
            <button class="px-5 py-2" mat-raised-button color="primary"
                (click)="navPrev()">{{translate.getLng('PREV')}}</button>
            <button class="px-5 py-2" mat-raised-button color="primary"
                (click)="navNext()">{{translate.getLng('NEXT')}}</button>
        </div>
    </section>
</section>
